import React from 'react'

import { PageHeader } from '@/components/headers/PageHeader'
import ReportsDashboardPage from './ReportsDashboardPage'
import { SecondaryNavRouter } from '../../../components/layout/SecondaryNavRouter/SecondaryNavRouter'
import LiveDashboardPage from './LiveDashboardPage'

export const DashboardPage = ({ tab }) => {
  const pages = [
    {
      label: 'Overview',
      component: <ReportsDashboardPage />,
      url: '/scorecards/dashboard/overview',
    },
    {
      label: 'Live Feed',
      component: <LiveDashboardPage />,
      url: '/scorecards/dashboard/live',
    },
  ]

  return (
    <>
      <PageHeader title="Dashboard" />

      <SecondaryNavRouter pages={pages} activePage={tab} />
    </>
  )
}

export default DashboardPage
